import { Box, makeStyles } from '@material-ui/core';
import React from 'react';

import ConnectionsBlock from './ConnectionsBlock';
import KeywordsBlock from './KeywordsBlock';

const HeaderPanel: React.FC = () => {
  const classes = useStyles();
  return (
    <Box className={classes.headerPanel}>
      <KeywordsBlock />
      <ConnectionsBlock />
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  headerPanel: {
    display: 'flex',
    flexWrap: 'wrap',
    overflow: 'hidden',
    width: '100%',
    height: '215px',
    marginTop: theme.spacing(8),
  },
}));

export default HeaderPanel;
